import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { API_BASE_URL } from '../../config';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { set } from 'react-hook-form';
import { get } from 'jquery';
import { LogoAdda } from '../../assets';
// Komponen preview struk sesuai gambar
function Print68({ orderItems, patients, workers }) {
    const user = useSelector(state => state.user);
    const location = useLocation();
    const [Klinik, setKlinik] = useState(null);
    const [transaction, setTransaction] = useState({});
    const [klinikLoading, setKlinikLoading] = useState(false);
    // Dummy: replace with real data fetch if needed

    const transactionState = useMemo(() => {
        return location.state?.transaction || {};
    }, [location.state]);

    const getKlinik = useCallback(async () => {
            //ambil dari API
            try{
                const token = localStorage.getItem("access_token");
                let url = `${API_BASE_URL}/auth/clinic_get_klinik/${transactionState?.klinik_id}`;
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    }
                });
                if(!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                if(data.code === 200){
                    setKlinik(data.data);
                }else{
                    console.log(data.message);
                }
            }catch(err){
                console.log(err);
            }
    }, [transactionState]);
    
    const getTransaction = useCallback(async () => {
        //ambil dari API
        try{
            const token = localStorage.getItem("access_token");
            let url = `${API_BASE_URL}/auth/patient_transaction/detail/${transactionState?.klinik_id}/${transactionState?.no_transaction}/${patients?.patient?.no_medical_record}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if(!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if(data.code === 200){
                setTransaction(data.data);
            }else{
                console.log(data.message);
            }
        }catch(err){
            console.log(err);
        }
    }, [patients, transactionState]);
    
    useEffect(() => {
        setKlinikLoading(true);
        Promise.all([
            getKlinik(),
            getTransaction()
        ]).finally(() => {
            setKlinikLoading(false);
        });
    }, [getKlinik, getTransaction]);

    const formatDatelocal = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        const date = new Date(dateString);
        return date.toLocaleDateString('id-ID', options);
    }

    const clinic = {
        name: Klinik ? Klinik.clinic_name : 'KHL Klinik Hang Lekiu',
        address: Klinik ? Klinik.address : 'Jl. Hang Lekiu III No. 10, RT.7/RW.4, Gunung, Kec. Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12120',
        logo: Klinik ? Klinik.klinik_detail?.logo : LogoAdda,
        phone: Klinik ? Klinik.klinik_detail?.phone : '021-12345678',
        email: Klinik ? Klinik.klinik_detail?.email : 'info@khlklinik.com',
        youtube: Klinik ? Klinik.klinik_detail?.youtube : 'KHLKlinikHangLekiu',
        facebook: Klinik ? Klinik.klinik_detail?.facebook : 'KHLKlinikHangLekiu',
        instagram: Klinik ? Klinik.klinik_detail?.instagram : 'KHLKlinikHangLekiu',
        twitter: Klinik ? Klinik.klinik_detail?.twitter : 'KHLKlinikHangLekiu',
        website: Klinik ? Klinik.klinik_detail?.website : 'www.khlklinikhanglekiu.com',
        whatsapp: Klinik ? Klinik?.klinik_detail?.whatsapp : '081234567890',
    };
    const receipt = {
        number: transaction ? transaction?.transaction?.no_transaction : 'RCP-0002',
        date: transaction ? transaction?.transaction?.created_at : '02 Jan 2023',
        medicalRecord: transaction ? transaction?.transaction?.no_medical_record : '000021',
        patient: transaction ? patients?.patient?.full_name : 'Yuliana Syahputri',
        collectedBy: transaction ? transaction?.transaction?.created_by_name : 'Maryanah Ulfa',
    };

    const items = transaction?.transaction?.details?.length >= 1 ? transaction?.transaction?.details : [];
    const subtotal = items.reduce((a, b) => a + Number(b.unit_price) * Number(b.qty), 0);
    const discTotal = items.reduce((a, b) => a + ( ( Number(b.unit_price) * Number(b.qty) ) - Number(b.final_price) ), 0);
    const total = items.reduce((a, b) => a + Number(b.final_price), 0);
    const totalPaid = Number(transaction?.transaction?.total_paid) || 0;

    return (
        <>
            <style>{`
                @media print {
                    body, html {
                        background: #fff !important;
                    }
                    .receipt-print-area {
                        margin: 0 auto !important;
                        box-shadow: none !important;
                        background: #fff !important;
                        padding: 0 !important;
                        width: 68mm !important;
                        min-width: 68mm !important;
                        max-width: 68mm !important;
                        display: block !important;
                    }
                }
                .receipt-print-area {
                    margin: 24px auto;
                    background: #fff;
                    width: 68mm;
                    min-width: 68mm;
                    max-width: 68mm;
                    box-shadow: 0 0 0 1px #eee;
                    padding: 0;
                    font-size: 9px;
                    font-family: monospace, Arial, Helvetica, sans-serif;
                    color: #000;
                    display: block;
                }
                .receipt-table68 {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                }
                .receipt-table68 th, .receipt-table68 td {
                    padding: 2px 0;
                    overflow: hidden;
                    white-space: nowrap;
                }
                .receipt-table68 th.item, .receipt-table68 td.item {
                    width: 38%;
                    text-align: left;
                }
                .receipt-table68 th.qty, .receipt-table68 td.qty {
                    width: 10%;
                    text-align: center;
                }
                .receipt-table68 th.price, .receipt-table68 td.price {
                    width: 18%;
                    text-align: right;
                }
                .receipt-table68 th.disc, .receipt-table68 td.disc {
                    width: 12%;
                    text-align: right;
                }
                .receipt-table68 th.total, .receipt-table68 td.total {
                    width: 22%;
                    text-align: right;
                }
            `}</style>
           
                <div className='receipt-print-area receipt-paper-68'>
                    <div style={{ textAlign: 'center', margin: 0, padding: '4px 0 2px 0' }}>
                        {clinic.logo && (
                            <img src={clinic.logo} alt="logo" style={{ height: 24, marginBottom: 2 }} />
                        )}
                        <div style={{ fontWeight: 700, fontSize: 10, marginBottom: 1 }}>{clinic.name}</div>
                        <div style={{ fontSize: 8, color: '#555', marginBottom: 1 }}>{clinic.address}</div>
                        <hr style={{ margin: '2px 0' }} />
                    </div>
                    <div style={{ fontSize: 8, marginBottom: 4, padding: '0 2px' }}>
                        <div>
                            Receipt: <b>{receipt.number}</b><br />
                            Date: {receipt.date}<br />
                            Medical Record: {receipt.medicalRecord}<br />
                            Patient: {receipt.patient}<br />
                            Cashier: {receipt.collectedBy}
                        </div>
                    </div>
                    <table className="receipt-table68" style={{ fontSize: 8, marginBottom: 4 }}>
                        <thead>
                            <tr style={{ borderBottom: '1px solid #ccc' }}>
                                <th className="item">Item</th>
                                <th className="qty">Qty</th>
                                <th className="price">Price</th>
                                <th className="disc">Disc</th>
                                <th className="total">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="item">
                                        {item.reference_type === 'treatment' ? item.treatment?.treatment_name :
                                            item.reference_type === 'product' ? item.product?.name :
                                            item.reference_type === 'medicine' ? item.product?.name :
                                            item.name}
                                        {item.doctor && <div style={{ fontSize: 7, color: '#888' }}>({item.doctor.full_name}/{item.therapist?.full_name})</div>}
                                    </td>
                                    <td className="qty">{item.qty}</td>
                                    <td className="price">{Number(item.total_price).toLocaleString('id-ID')}</td>
                                    <td className="disc">{item.discount_value ? item.discount_value + '%' : '0.00'}</td>
                                    <td className="total">{Number(item.final_price).toLocaleString('id-ID')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{ fontSize: 8, marginBottom: 4, padding: '0 2px' }}>
                        <table style={{ width: '100%', fontSize: 8, border: 0 }}>
                            <tbody>
                                <tr><td>Subtotal</td><td style={{ textAlign: 'right' }}>Rp. {subtotal.toLocaleString('id-ID')}</td></tr>
                                <tr><td>Discount</td><td style={{ textAlign: 'right' }}>Rp. {discTotal.toLocaleString('id-ID')}</td></tr>
                                <tr style={{ fontWeight: 'bold' }}><td>Total</td><td style={{ textAlign: 'right' }}>Rp. {total.toLocaleString('id-ID')}</td></tr>
                                <tr><td>Paid</td><td style={{ textAlign: 'right' }}>Rp. {totalPaid.toLocaleString('id-ID')}</td></tr>
                                {
                                    transaction?.payments ? transaction?.payments?.map((pay, index) => (
                                        <tr key={index}>
                                            <td>{pay.payment_method} :</td>
                                            <td style={{ textAlign: 'right', fontWeight: 700 }}>Rp. {Number(pay.amount).toLocaleString('id-ID')}</td>
                                        </tr>
                                    )) : null
                                }
                            </tbody>
                        </table>
                    </div>
                    <div style={{ fontSize: 7, marginTop: 4, borderTop: '1px solid #eee', paddingTop: 2, textAlign: 'center' }}>
                        <b>CONTACT</b><br />
                        {clinic.name}<br />
                        IG: {clinic.instagram} | {clinic.website}<br />
                        {clinic.facebook}<br />
                        Ref: {receipt.number}<br />
                        For questions contact us at WhatsApp
                    </div>
                </div>
            )}
        </>
    );
}

export default Print68;

// Cara penggunaan:
// <ReceiptPrintPreview orderItems={orderItems} patients={patients} workers={workers} />